import { KeyValue } from 'ngrx-forms';

import { createActionsFactory } from './actions';
import { createInitialStateFactory } from './initialState';
import { createReducerFactory } from './reducer';
import { createSelectorsFactory } from './selectors';

export function createLazyState<Entity, EntityFormValue extends KeyValue>(
  entityName: string,
  initialFormValue: EntityFormValue
) {
  const ENTITY_FORM_ID = entityName + '_FORM_ID';
  const ENTITY_FILTER_FORM_ID = entityName + '_FILTER_FORM_ID';
  const stateFactory = createInitialStateFactory<Entity, EntityFormValue>(
    ENTITY_FORM_ID,
    ENTITY_FILTER_FORM_ID,
    initialFormValue
  );

  const selectorsFactory = createSelectorsFactory<Entity, EntityFormValue>();

  const actionsFacory = createActionsFactory<Entity, EntityFormValue>(
    entityName
  );

  const reducerFactory = createReducerFactory<Entity, EntityFormValue>(
    entityName
  );

  return {
    ...stateFactory,
    ...selectorsFactory,
    ...actionsFacory,
    ...reducerFactory,
    ENTITY_FORM_ID,
    ENTITY_FILTER_FORM_ID,
  };
}
